function getBaseUrl() {
    const origin = window.location.origin;
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;

    if (process.env.REACT_APP_WORKING_ENV === 'local') {
        const devPort = process.env.REACT_APP_API_PORT;

        return `${protocol}//api.${hostname}:${devPort}`;
    }

    return `${protocol}//api.${hostname}`;
}


const BASE_URL = getBaseUrl()


export const authToken = () => {
    let tokenInStorage = localStorage.getItem("authToken");
    return tokenInStorage ? `Bearer ${tokenInStorage}` : "";
}

// you should theoretically be able to pass in token to make requests as a different user
export const makeRequest = async (url, method = 'GET', body = {}, token= "", customHeaders = {}) => {
    if (!url.startsWith('/')) url = `/${url}`
    const fullUrl = `${BASE_URL}/api/v1${url}`;
    const headers = new Headers();
    headers.set("Authorization", token ? `Bearer ${token}` : authToken());
    headers.set("Content-Type", "application/json");
    Object.keys(customHeaders).forEach(key => {
        headers.set(key, customHeaders[key]);
    });
    const response = await fetch(fullUrl, {
        method: method,
        mode: 'cors',
        headers: headers,
        body: ["GET", "HEAD"].includes(method) ? null : JSON.stringify(body),
    })
    if (response.status === 500) return response;

    let data;
    try {
        data = await response.json()
    } catch (e) {
        // If response is not valid JSON, throw with status text
        if (response.status >= 400) {
            throw new Error(response.statusText || `Request failed with status ${response.status}`);
        }
        throw e;
    }

    if (response.status >= 400) {
        if (response.status === 403) {
            return 403
        }
        const errorMessage = data?.error || data?.message || `Request failed with status ${response.status}`;
        throw new Error(errorMessage);
    }
    return data;
}